/**
 * Kebab-cases arbitrary display copy into a stable testid fragment.
 * @param value
 */
export const toTestId = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
